import { createBrowserHistory } from 'history';

import { APP_PREFIX } from '@/utils/constants';
import appStore from 'stores/app';

import Cookies from './cookies-helper';

function getSession() {
  return Cookies.getSessionId() || JSON.parse(localStorage.getItem('session') || '{}').session_id
}

class DynamicBasename extends String {
  constructor(getter) {
    super(getter())
    this.getBasename = getter
  }

  [Symbol.toPrimitive]() { return this.getBasename() }
  valueOf() { return this.getBasename() }
  toString() { return this.getBasename() }
  toJSON() { return this.getBasename() }
}

export default createBrowserHistory({
  basename: new DynamicBasename(() => getSession() && appStore.site ? `${APP_PREFIX}/${appStore.site.id}` : APP_PREFIX),
});
